import axios from 'axios';
import BaseAPI from './base/base-api';

class AbbreviationSetupAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'abbreviationsetup';
}

export default new AbbreviationSetupAPI();